var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filters-list",
      on: {
        scroll: function ($event) {
          return _vm.scrollHandler($event)
        },
      },
    },
    _vm._l(_vm.filtersList, function (item, index) {
      return _c("filter-item", {
        key: "filter-item-" + index,
        attrs: { "filter-name": item, "is-active": item === _vm.activeFilter },
        on: { "change-filter": _vm.changeFilterHandler },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }